module.exports = __webpack_public_path__ + "img/task-square(1).3ed12252.svg";